export const BUSINESS_CASE_FACTS_KINDS = ['businessCase'] as const;
